import {UnauthorizedError} from '../api/errors'
import {apiFetch} from '../api/fetch'
import {type LoginResponse, loginResponseSchema, userResponseSchema} from './schemas'
import type {AuthUser} from './types'

export type UserResponse = AuthUser

export async function login(email: string): Promise<LoginResponse> {
    const raw = await apiFetch<unknown>('/auth/login', {
        method: 'POST',
        body: JSON.stringify({email}),
    })
    return loginResponseSchema.parse(raw)
}

export async function verify(token: string): Promise<UserResponse> {
    const raw = await apiFetch<unknown>('/auth/verify', {
        method: 'POST',
        body: JSON.stringify({token}),
    })
    return userResponseSchema.parse(raw)
}

export async function logout(): Promise<void> {
    await apiFetch('/auth/logout', {method: 'POST'})
}

export async function fetchMe(): Promise<UserResponse> {
    const raw = await apiFetch<unknown>('/auth/me')
    return userResponseSchema.parse(raw)
}

export {UnauthorizedError}
